import angular from 'angular';
import { MeurhMudancaHorarioService } from '../mudancahorario.service';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { IMudancaHorario } from '../models/mudancahorario.model';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';

type IMeurhMudancaHorarioIndexFilter = {
    empresa?: string;
    estabelecimento?: string;
    situacao?: string;
    lotacao?: {
        lotacao: string;
    } | null;
};

export class MeurhMudancaHorarioIndexController {
    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        'MeurhMudancaHorarioService',
        'ListagemService'
    ];

    public entities: Array<IMudancaHorario>;
    public busy: boolean = false;
    public filters: IMeurhMudancaHorarioIndexFilter = {};

    public empresas: Array<Empresa>;
    public estabelecimentos: Array<Estabelecimento>;
    public listagemPermissao: Array<string> = ['visualizar_mudancahorario'];
    public permissaoGrupoEmpresarial = false;

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissao: (arg: string) => boolean,
            liberadoTela: (arg: string) => boolean,
            temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
            session: any,
            nsjGlobals: any
        },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public $stateParams: angular.ui.IStateParamsService,
        public $location: angular.ILocationService,
        public entityService: MeurhMudancaHorarioService,
        public ListagemService: ListagemService
    ) {
        if ($rootScope.liberadoTela('LIBERAR_CALENDARIO_HORARIO')) {
            $state.go('dp');
        }

        entityService.filter = $stateParams['q'] ? $stateParams['q'] : '';
        entityService.filters = {};
        entityService.constructors = {};

        this.permissaoGrupoEmpresarial = $rootScope.temPermissaoGrupoEmpresarial(
            this.listagemPermissao,
            $rootScope.nsjGlobals.a.grupoempresarial
        );

        this.filters = {
            ...this.filters,
            empresa: $rootScope.session.entities.empresa.empresa,
            estabelecimento: $rootScope.session.entities.estabelecimento.estabelecimento,
        };

        this.montaListagemVisibilidade();
        this.entities = this.filterReload();

        $scope.$on('meurh_solicitacoesmudancahorario_list_finished', () => {
            this.busy = false;
        });

        $scope.$on('meurh_solicitacoesmudancahorario_loaded', () => {
            this.busy = false;
        });

        $scope.$on('meurh_solicitacoesmudancahorario_submitted', () => {
            this.busy = false;
            this.entities = [];
            this.entities = this.entityService.reload();
        });

        $scope.$on('meurh_solicitacoesmudancahorario_deleted', () => {
            this.busy = false;
            this.entities = [];
            this.entities = this.entityService.reload();
        });
    }

    montaListagemVisibilidade() {
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa!, this.empresas, this.listagemPermissao);
    }

    mudaEstabelecimentos() {
        this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao) : [];
        this.filters.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    filtraEmpresaEstabelecimento() {
        delete this.filters.lotacao;
        this.$rootScope.$broadcast('lotacao_refresh', this.constructorEmpresaEstabelecimento());
        this.filterReload();
    }

    constructorEmpresaEstabelecimento() {
        return {
            'empresa': this.filters.empresa,
            'estabelecimento': this.filters.estabelecimento
        };
    }

    search(): Array<IMudancaHorario> {
        if (this.entityService.filter !== '') {
            this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters, { 'q': this.entityService.filter }));
        } else {
            this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters));
        }

        const filter = {
            search: this.entityService.filter,
            filters: angular.copy(this.entityService.filters)
        };
        return this.entityService.search(filter);
    }

    filterReload(): Array<IMudancaHorario> {
        const constructors: any = { ...this.filters };

        if (!this.valorExiste(constructors.lotacao)) {
            delete constructors.lotacao;
        } else {
            constructors.lotacao = constructors.lotacao.lotacao;
        }

        if (!this.valorExiste(constructors.situacao)) {
            delete constructors.situacao;
        }

        this.entityService.constructors = constructors;
        return this.entityService.reload();
    }

    loadMore(): void {
        this.entityService.loadMore();
    }

    isBusy(): boolean {
        return this.entityService.loadParams.busy;
    }

    valorExiste(valor: any): boolean {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }
}
